import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UrlService {

  constructor(
  ) { }

  private isEncoded(uri:string) {
    uri = uri || '';
    return uri !== decodeURIComponent(uri);
  }

  public fullyDecodeURI(uri:string){
    while (this.isEncoded(uri)){
      uri = decodeURIComponent(uri);
    }
   return uri;
  }

  public cleanUrl(url: string): Array <string> {
    let routePart = url.split('/').map((i:string)=> this.fullyDecodeURI(i)).filter((i:string)=> i != ''); 
    return routePart;
  }
}
